import { render, staticRenderFns } from "./OhGroups.vue?vue&type=template&id=64b2af58&scoped=true&"
import script from "./OhGroups.vue?vue&type=script&lang=js&"
export * from "./OhGroups.vue?vue&type=script&lang=js&"
import style0 from "./OhGroups.vue?vue&type=style&index=0&id=64b2af58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b2af58",
  null
  
)

export default component.exports